/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventTimeType = "Date" | "DateTime" | "%future added value";
export type EventTrait = "Autopilot" | "IndividualHold" | "LinkEvent" | "LunchHold" | "OneOnOne" | "TaskHold" | "%future added value";
export type Inconveniences = "External" | "MissedLunch" | "NoMeetingRelief" | "OnNoMeetingDay" | "Other" | "OutsideMeetingHours" | "OutsideWorkingHours" | "Uncrawled" | "%future added value";
export type SchedulingAttendanceSummaryTag = "Best" | "Conflict" | "Current" | "Good" | "InFocusTime" | "Inconvenient" | "MostFocus" | "OverLunch" | "Soonest" | "%future added value";
export type SchedulingResponseQualifier = "NoConvenientTimesWithRooms" | "%future added value";
export type TimeSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type Unavailabilities = "FarOutsideWorkingHours" | "%future added value";
export type SchedulingQueryInput = {
    includeConflictSuggestions?: boolean | null | undefined;
    includeRoom: boolean;
    invitees: Array<InviteeContextInput | null>;
    limit: number;
    maxSlot: DayTimeSlotInput;
    minSlot: DayTimeSlotInput;
    minutesDuration: number;
    roomsOverride: Array<string | null>;
    seenSlots: Array<DayTimeSlotInput | null>;
    timeZone: string;
    traits?: Array<EventTrait | null> | null | undefined;
};
export type InviteeContextInput = {
    calendarId: string;
    required: boolean;
};
export type DayTimeSlotInput = {
    date: string;
    timeSlot: TimeSlot;
};
export type SuggestedTimesQueryVariables = {
    orgRelayId: string;
    query: SchedulingQueryInput;
};
export type SuggestedTimesQueryResponse = {
    readonly node: {
        readonly id: string;
        readonly schedulingResponseErrorable?: {
            readonly __typename: "SchedulingResponse";
            readonly uncrawledCalendars: ReadonlyArray<string | null>;
            readonly qualifiers: ReadonlyArray<SchedulingResponseQualifier | null> | null;
            readonly queryRecommendation: {
                readonly minutesDuration: string | null;
                readonly availableDate: string | null;
            } | null;
            readonly slots: ReadonlyArray<{
                readonly summary: {
                    readonly availableRooms: ReadonlyArray<string>;
                    readonly tags: ReadonlyArray<SchedulingAttendanceSummaryTag | null> | null;
                    readonly freeAttendees: ReadonlyArray<string>;
                    readonly inconvenientForAttendees: ReadonlyArray<string>;
                    readonly unavailableAttendees: ReadonlyArray<string>;
                    readonly focusTimeMinutesCost: number;
                    readonly conflictingAttendees: ReadonlyArray<string>;
                };
                readonly attendanceImpacts: ReadonlyArray<{
                    readonly hasConflict: boolean;
                    readonly calendarId: string;
                    readonly focusTimeMinutesCost: number;
                    readonly inconveniences: ReadonlyArray<Inconveniences>;
                    readonly unavailabilities: ReadonlyArray<Unavailabilities>;
                    readonly conflictingMeetings: ReadonlyArray<string>;
                }>;
                readonly roomImpacts: ReadonlyArray<{
                    readonly roomId: string;
                    readonly available: boolean;
                }>;
                readonly timeRange: {
                    readonly id: string;
                    readonly startTime: {
                        readonly type: EventTimeType;
                        readonly dateOrDateTime: string;
                        readonly timeZone: string | null;
                        readonly offsetMinutes: number | null;
                        readonly millis: number;
                    } | null;
                    readonly endTime: {
                        readonly type: EventTimeType;
                        readonly dateOrDateTime: string;
                        readonly timeZone: string | null;
                        readonly offsetMinutes: number | null;
                        readonly millis: number;
                    } | null;
                } | null;
            }>;
            readonly " $fragmentRefs": FragmentRefs<"EventSchedulerSuggestedTimes_schedulingResponse">;
        } | {
            readonly __typename: "GraphEntityError";
            readonly message: string | null;
            readonly statusCode: number | null;
            readonly body: string | null;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        } | undefined;
    } | null;
};
export type SuggestedTimesQuery = {
    readonly response: SuggestedTimesQueryResponse;
    readonly variables: SuggestedTimesQueryVariables;
};



/*
query SuggestedTimesQuery(
  $orgRelayId: ID!
  $query: SchedulingQueryInput!
) {
  node(id: $orgRelayId) {
    __typename
    id
    ... on Org {
      schedulingResponseErrorable(query: $query) {
        __typename
        __isSchedulingResponseErrorable: __typename
        ... on SchedulingResponse {
          ...EventSchedulerSuggestedTimes_schedulingResponse
          uncrawledCalendars
          qualifiers
          queryRecommendation {
            minutesDuration
            availableDate
          }
          slots {
            summary {
              availableRooms
              tags
              freeAttendees
              inconvenientForAttendees
              unavailableAttendees
              focusTimeMinutesCost
              conflictingAttendees
            }
            attendanceImpacts {
              hasConflict
              calendarId
              focusTimeMinutesCost
              inconveniences
              unavailabilities
              conflictingMeetings
            }
            roomImpacts {
              roomId
              available
            }
            timeRange {
              id
              startTime {
                type
                dateOrDateTime
                timeZone
                offsetMinutes
                millis
              }
              endTime {
                type
                dateOrDateTime
                timeZone
                offsetMinutes
                millis
              }
            }
          }
        }
        ... on GraphEntityError {
          message
          statusCode
          body
        }
      }
    }
  }
}

fragment EventSchedulerSuggestedTime_schedulingSlot on SchedulingSlot {
  summary {
    availableRooms
    tags
    freeAttendees
    inconvenientForAttendees
    unavailableAttendees
    focusTimeMinutesCost
    conflictingAttendees
  }
  attendanceImpacts {
    calendarId
    inconveniences
    unavailabilities
    hasConflict
    focusTimeMinutesCost
    conflictingMeetings
  }
  roomImpacts {
    roomId
    available
    tooSmall
    tooLarge
  }
  timeRange {
    id
    startTime {
      type
      dateOrDateTime
      timeZone
      offsetMinutes
      millis
    }
    endTime {
      type
      dateOrDateTime
      timeZone
      offsetMinutes
      millis
    }
  }
}

fragment EventSchedulerSuggestedTimes_schedulingResponse on SchedulingResponse {
  uncrawledCalendars
  qualifiers
  queryRecommendation {
    availableDate
    minutesDuration
  }
  slots {
    ...EventSchedulerSuggestedTime_schedulingSlot
    summary {
      availableRooms
      tags
      freeAttendees
      inconvenientForAttendees
      focusTimeMinutesCost
      conflictingAttendees
    }
    attendanceImpacts {
      calendarId
      inconveniences
      hasConflict
      focusTimeMinutesCost
      conflictingMeetings
    }
    roomImpacts {
      available
      tooSmall
      tooLarge
      roomId
    }
    timeRange {
      id
      startTime {
        type
        dateOrDateTime
        timeZone
        offsetMinutes
        millis
      }
      endTime {
        type
        dateOrDateTime
        timeZone
        offsetMinutes
        millis
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "orgRelayId"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "query"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = [
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        } as any
    ], v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uncrawledCalendars",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "qualifiers",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "minutesDuration",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "availableDate",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "focusTimeMinutesCost",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "concreteType": "SchedulingAttendanceSummary",
        "kind": "LinkedField",
        "name": "summary",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "availableRooms",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tags",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "freeAttendees",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "inconvenientForAttendees",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unavailableAttendees",
                "storageKey": null
            },
            (v9 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "conflictingAttendees",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasConflict",
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarId",
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "inconveniences",
        "storageKey": null
    } as any, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unavailabilities",
        "storageKey": null
    } as any, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "conflictingMeetings",
        "storageKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "roomId",
        "storageKey": null
    } as any, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "available",
        "storageKey": null
    } as any, v18 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOrDateTime",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeZone",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offsetMinutes",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "millis",
            "storageKey": null
        } as any
    ], v19 = {
        "alias": null,
        "args": null,
        "concreteType": "TimeRange",
        "kind": "LinkedField",
        "name": "timeRange",
        "plural": false,
        "selections": [
            (v2 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "EventTime",
                "kind": "LinkedField",
                "name": "startTime",
                "plural": false,
                "selections": (v18 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "EventTime",
                "kind": "LinkedField",
                "name": "endTime",
                "plural": false,
                "selections": (v18 /*: any*/),
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statusCode",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "body",
                "storageKey": null
            }
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SuggestedTimesQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "schedulingResponseErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v5 /*: any*/),
                                                (v6 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "QueryRecommendation",
                                                    "kind": "LinkedField",
                                                    "name": "queryRecommendation",
                                                    "plural": false,
                                                    "selections": [
                                                        (v7 /*: any*/),
                                                        (v8 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SchedulingSlot",
                                                    "kind": "LinkedField",
                                                    "name": "slots",
                                                    "plural": true,
                                                    "selections": [
                                                        (v10 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "SchedulingAttendanceImpact",
                                                            "kind": "LinkedField",
                                                            "name": "attendanceImpacts",
                                                            "plural": true,
                                                            "selections": [
                                                                (v11 /*: any*/),
                                                                (v12 /*: any*/),
                                                                (v9 /*: any*/),
                                                                (v13 /*: any*/),
                                                                (v14 /*: any*/),
                                                                (v15 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "SchedulingRoomImpact",
                                                            "kind": "LinkedField",
                                                            "name": "roomImpacts",
                                                            "plural": true,
                                                            "selections": [
                                                                (v16 /*: any*/),
                                                                (v17 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v19 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "args": null,
                                                    "kind": "FragmentSpread",
                                                    "name": "EventSchedulerSuggestedTimes_schedulingResponse"
                                                }
                                            ],
                                            "type": "SchedulingResponse",
                                            "abstractKey": null
                                        },
                                        (v20 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SuggestedTimesQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        (v2 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "schedulingResponseErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isSchedulingResponseErrorable"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v5 /*: any*/),
                                                (v6 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "QueryRecommendation",
                                                    "kind": "LinkedField",
                                                    "name": "queryRecommendation",
                                                    "plural": false,
                                                    "selections": [
                                                        (v8 /*: any*/),
                                                        (v7 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SchedulingSlot",
                                                    "kind": "LinkedField",
                                                    "name": "slots",
                                                    "plural": true,
                                                    "selections": [
                                                        (v10 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "SchedulingAttendanceImpact",
                                                            "kind": "LinkedField",
                                                            "name": "attendanceImpacts",
                                                            "plural": true,
                                                            "selections": [
                                                                (v12 /*: any*/),
                                                                (v13 /*: any*/),
                                                                (v14 /*: any*/),
                                                                (v11 /*: any*/),
                                                                (v9 /*: any*/),
                                                                (v15 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "SchedulingRoomImpact",
                                                            "kind": "LinkedField",
                                                            "name": "roomImpacts",
                                                            "plural": true,
                                                            "selections": [
                                                                (v16 /*: any*/),
                                                                (v17 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "tooSmall",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "tooLarge",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v19 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "SchedulingResponse",
                                            "abstractKey": null
                                        },
                                        (v20 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "203598d43f8a3ea325e01ca21db054f2",
            "id": null,
            "metadata": {},
            "name": "SuggestedTimesQuery",
            "operationKind": "query",
            "text": "query SuggestedTimesQuery(\n  $orgRelayId: ID!\n  $query: SchedulingQueryInput!\n) {\n  node(id: $orgRelayId) {\n    __typename\n    id\n    ... on Org {\n      schedulingResponseErrorable(query: $query) {\n        __typename\n        __isSchedulingResponseErrorable: __typename\n        ... on SchedulingResponse {\n          ...EventSchedulerSuggestedTimes_schedulingResponse\n          uncrawledCalendars\n          qualifiers\n          queryRecommendation {\n            minutesDuration\n            availableDate\n          }\n          slots {\n            summary {\n              availableRooms\n              tags\n              freeAttendees\n              inconvenientForAttendees\n              unavailableAttendees\n              focusTimeMinutesCost\n              conflictingAttendees\n            }\n            attendanceImpacts {\n              hasConflict\n              calendarId\n              focusTimeMinutesCost\n              inconveniences\n              unavailabilities\n              conflictingMeetings\n            }\n            roomImpacts {\n              roomId\n              available\n            }\n            timeRange {\n              id\n              startTime {\n                type\n                dateOrDateTime\n                timeZone\n                offsetMinutes\n                millis\n              }\n              endTime {\n                type\n                dateOrDateTime\n                timeZone\n                offsetMinutes\n                millis\n              }\n            }\n          }\n        }\n        ... on GraphEntityError {\n          message\n          statusCode\n          body\n        }\n      }\n    }\n  }\n}\n\nfragment EventSchedulerSuggestedTime_schedulingSlot on SchedulingSlot {\n  summary {\n    availableRooms\n    tags\n    freeAttendees\n    inconvenientForAttendees\n    unavailableAttendees\n    focusTimeMinutesCost\n    conflictingAttendees\n  }\n  attendanceImpacts {\n    calendarId\n    inconveniences\n    unavailabilities\n    hasConflict\n    focusTimeMinutesCost\n    conflictingMeetings\n  }\n  roomImpacts {\n    roomId\n    available\n    tooSmall\n    tooLarge\n  }\n  timeRange {\n    id\n    startTime {\n      type\n      dateOrDateTime\n      timeZone\n      offsetMinutes\n      millis\n    }\n    endTime {\n      type\n      dateOrDateTime\n      timeZone\n      offsetMinutes\n      millis\n    }\n  }\n}\n\nfragment EventSchedulerSuggestedTimes_schedulingResponse on SchedulingResponse {\n  uncrawledCalendars\n  qualifiers\n  queryRecommendation {\n    availableDate\n    minutesDuration\n  }\n  slots {\n    ...EventSchedulerSuggestedTime_schedulingSlot\n    summary {\n      availableRooms\n      tags\n      freeAttendees\n      inconvenientForAttendees\n      focusTimeMinutesCost\n      conflictingAttendees\n    }\n    attendanceImpacts {\n      calendarId\n      inconveniences\n      hasConflict\n      focusTimeMinutesCost\n      conflictingMeetings\n    }\n    roomImpacts {\n      available\n      tooSmall\n      tooLarge\n      roomId\n    }\n    timeRange {\n      id\n      startTime {\n        type\n        dateOrDateTime\n        timeZone\n        offsetMinutes\n        millis\n      }\n      endTime {\n        type\n        dateOrDateTime\n        timeZone\n        offsetMinutes\n        millis\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '9b27045dd0ca79e1d2eee3e0dc05fabc';
export default node;
